import {
  RESET_EDITPROFILE,
  RESET_ERROR,
  API_ERROR,
  GET_EDITPROFILE,
  SET_EDITPROFILE,
  EDIT_EDITPROFILE,
  EDIT_EDITPROFILE_SUCCESS,
} from "./actionTypes";

export const resetEditProfile = () => {
  return {
    type: RESET_EDITPROFILE,
    payload: {},
  };
};

export const resetError = () => {
  return {
    type: RESET_ERROR,
    payload: {},
  };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};

export const getEditProfile = (idEditProfile, isForm) => {
  return {
    type: GET_EDITPROFILE,
    payload: { idEditProfile, isForm },
  };
};
export const setEditProfile = (data) => {
  return {
    type: SET_EDITPROFILE,
    payload: { data },
  };
};

export const editEditProfile = (idEditProfile, newEditProfileValues) => {
  return {
    type: EDIT_EDITPROFILE,
    payload: { idEditProfile, newEditProfileValues },
  };
};
export const editEditProfileSuccess = (message) => {
  return {
    type: EDIT_EDITPROFILE_SUCCESS,
    payload: { message },
  };
};
